// extracted by mini-css-extract-plugin
export var productImage = "_q9-0";